import React from "react";

export default function RefundPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-semibold mb-6">PRObroker Refund Policy</h1>

      <p className="mb-4"><strong>Last Updated:</strong> 09/02/2026</p>

      <p className="mb-4">
        This Policy governs refunds, cancellations and subscription terms for services purchased from PRObroker. All users should carefully review plan details, access scope and tenure prior to purchase.
      </p>

      <p className="mb-4">
        All subscription fees and charges paid to PRObroker are non refundable by default once a subscription is activated, regardless of usage, deals closed, or business outcomes. Non use of the platform, lack of transactions or dissatisfaction with commission outcomes do not entitle you to refunds or credits.
      </p>

      <p className="mb-4">Refunds may be considered only in the following limited circumstances:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>where you are accidentally charged twice for the same subscription term, subject to due verification with our payment records.</li>
        <li>where your payment is debited but the subscription is not activated and access is not provisioned within a reasonable time of 14 days, and you choose not to continue with activation once offered. The latter option shall be available at the expiry of the 14 day period.</li>
        <li>where continuation of the service becomes illegal solely due to a change in law or regulatory order specific to PRObroker, making performance impossible.</li>
      </ul>

      <p className="mb-4">
        Any such refund will be processed after internal verification and may be subject to deduction of payment gateway or processing charges, where applicable.
      </p>

      <p className="mb-4">
        We will make reasonable efforts to resolve technical issues affecting access (e.g., login failures, feature malfunctions) within a reasonable period. Temporary downtime, maintenance, or intermittent issues do not, by themselves, constitute grounds for refunds. Where a persistent platform level technical failure (not attributable to your devices, network or misuse) prevents you from accessing core subscribed services for a continuous period exceeding 3 business days, we may support and provide an extension of subscription tenure.
      </p>

      <p className="mb-4">
        We do not guarantee any minimum number of deals, conversions, returns or revenue. Subscriptions are for access to tools and data, not for guaranteed closings or profitability; hence there is no success based entitlement or chargeback right on that basis.
      </p>

      <p className="mb-4">
        You may request cancellation of auto renewals (if enabled) by following the instructions provided on the platform, or by contacting support at least 3 days prior to the renewal date. Cancellation of auto renewal will stop future billing but does not entitle you to a refund for the current active term. We may discontinue or alter subscription plans and pricing with prospective effect, with notice where practicable.
      </p>
    </div>
  );
}
